var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main personal-center", style: _vm.themeStyle },
    [
      _c(
        "div",
        { staticClass: "box" },
        [
          _c("Header"),
          _c("GameBanner", {
            attrs: {
              src: _vm.gameData.topBgImage,
              variant: _vm.gameData.extraFields.bannerType,
              drawProductId: _vm.gameData.extraFields.bannerDrawProductId,
            },
          }),
          _c("div", { staticClass: "personal-center-body" }, [
            _c(
              "div",
              { staticClass: "content" },
              [
                _c("UserInfo", {
                  ref: "userInfo",
                  attrs: { "show-summary": false },
                }),
                _c("section", { staticClass: "position" }, [
                  _c("aside", { staticClass: "side-panel" }, [
                    _c("div", { staticClass: "account-nav-header" }, [
                      _c("i", {
                        staticClass: "el-icon-box account-nav-icon",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _c("h1", { staticClass: "account-nav-title" }, [
                        _vm._v(_vm._s(_vm.$t("personalCenter.title"))),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "ledger-menu" },
                      _vm._l(_vm.categories, function (item) {
                        return _c(
                          "button",
                          {
                            key: item.value,
                            staticClass: "ledger-card",
                            class: { active: _vm.category === item.value },
                            attrs: {
                              type: "button",
                              "aria-current":
                                _vm.category === item.value ? "page" : null,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.selectCategory(item.value)
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "ledger-icon",
                              class: item.icon,
                              attrs: { "aria-hidden": "true" },
                            }),
                            _c("span", { staticClass: "ledger-title" }, [
                              _vm._v(_vm._s(item.label)),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                  _c(
                    "section",
                    { staticClass: "main-panel" },
                    [
                      _vm.category === "exchange"
                        ? _c("section", { staticClass: "quick-panel" }, [
                            _c("div", [
                              _c("div", { staticClass: "quick-title" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("personalCenter.redeem_gift"))
                                ),
                              ]),
                              _c("div", { staticClass: "quick-sub" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("personalCenter.redeem_description")
                                  )
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "redeem-row" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.redeemCode,
                                    expression: "redeemCode",
                                    modifiers: { trim: true },
                                  },
                                ],
                                staticClass: "redeem-input",
                                attrs: {
                                  "aria-label": _vm.$t(
                                    "personalCenter.redeem_code"
                                  ),
                                  placeholder: _vm.$t(
                                    "personalCenter.redeem_code_placeholder"
                                  ),
                                  disabled: _vm.isRedeeming,
                                },
                                domProps: { value: _vm.redeemCode },
                                on: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    )
                                      return null
                                    return _vm.redeem.apply(null, arguments)
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.redeemCode = $event.target.value.trim()
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                              _c(
                                "button",
                                {
                                  staticClass: "primary-button",
                                  attrs: {
                                    type: "button",
                                    disabled: _vm.isRedeeming,
                                  },
                                  on: { click: _vm.redeem },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.isRedeeming
                                          ? _vm.$t("personalCenter.redeeming")
                                          : _vm.$t("personalCenter.redeem_now")
                                      ) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.category !== "vip"
                        ? _c("section", { staticClass: "record-panel" }, [
                            _c("div", { staticClass: "record-list" }, [
                              _vm.pageRecords.length
                                ? _c(
                                    "div",
                                    { staticClass: "record-table" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "table-row-head",
                                          class: _vm.category + "-grid",
                                        },
                                        _vm._l(
                                          _vm.headings,
                                          function (heading) {
                                            return _c(
                                              "span",
                                              { key: heading },
                                              [_vm._v(_vm._s(heading))]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                      _vm._l(
                                        _vm.pageRecords,
                                        function (record) {
                                          return _c(
                                            "div",
                                            {
                                              key: record.id,
                                              staticClass: "table-row-item",
                                              class: _vm.category + "-grid",
                                            },
                                            [
                                              _vm.category === "exchange"
                                                ? [
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          "data-label": _vm.$t(
                                                            "personalCenter.exchange_time"
                                                          ),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(record.time)
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          "data-label": _vm.$t(
                                                            "personalCenter.redeem_code"
                                                          ),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(record.title)
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          "data-label": _vm.$t(
                                                            "personalCenter.reward_content"
                                                          ),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(record.desc)
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          "data-label": _vm.$t(
                                                            "personalCenter.status"
                                                          ),
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "status",
                                                            class: record.badge,
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "personalCenter.exchange_success"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                : _vm.category === "points"
                                                ? [
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          "data-label": _vm.$t(
                                                            "personalCenter.time"
                                                          ),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(record.time)
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          "data-label": _vm.$t(
                                                            "personalCenter.type"
                                                          ),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(record.status)
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        class:
                                                          record.valueClass,
                                                        attrs: {
                                                          "data-label": _vm.$t(
                                                            "personalCenter.points_change"
                                                          ),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(record.value)
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          "data-label": _vm.$t(
                                                            "personalCenter.balance"
                                                          ),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(record.balance)
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                : _vm.category === "lottery"
                                                ? [
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          "data-label": _vm.$t(
                                                            "personalCenter.lottery_time"
                                                          ),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(record.time)
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          "data-label": _vm.$t(
                                                            "personalCenter.reward"
                                                          ),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(record.title)
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                : [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "order-cell",
                                                        attrs: {
                                                          "data-label": _vm.$t(
                                                            "personalCenter.order_id"
                                                          ),
                                                        },
                                                      },
                                                      [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(record.title)
                                                          ),
                                                        ]),
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "copy-button",
                                                            attrs: {
                                                              type: "button",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.copyText(
                                                                  record.title
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "personalCenter.copy"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          "data-label": _vm.$t(
                                                            "personalCenter.payment_channel"
                                                          ),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(record.desc)
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          "data-label": _vm.$t(
                                                            "personalCenter.amount"
                                                          ),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(record.value)
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          "data-label": _vm.$t(
                                                            "personalCenter.server"
                                                          ),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(record.meta[1])
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          "data-label": _vm.$t(
                                                            "personalCenter.role"
                                                          ),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(record.meta[2])
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          "data-label": _vm.$t(
                                                            "personalCenter.payment_time"
                                                          ),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            record.meta[3] ||
                                                              record.time
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                            ],
                                            2
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _c("div", { staticClass: "empty-state" }, [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.isCurrentCategoryLoading
                                            ? _vm.$t("personalCenter.loading")
                                            : _vm.$t(
                                                "personalCenter.no_records"
                                              )
                                        )
                                      ),
                                    ]),
                                    !_vm.isCurrentCategoryLoading
                                      ? _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "personalCenter.no_content"
                                              )
                                            )
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                            ]),
                            _vm.pageRecords.length || _vm.totalPages > 1
                              ? _c("div", { staticClass: "pagination" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "page-button",
                                      attrs: {
                                        type: "button",
                                        disabled:
                                          _vm.page === 1 ||
                                          _vm.isCurrentCategoryLoading,
                                      },
                                      on: { click: _vm.prevPage },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("personalCenter.previous")
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("span", { staticClass: "page-info" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("personalCenter.page_info", {
                                          current: _vm.page,
                                          total: _vm.totalPages,
                                        })
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "page-button",
                                      attrs: {
                                        type: "button",
                                        disabled:
                                          _vm.page === _vm.totalPages ||
                                          _vm.isCurrentCategoryLoading,
                                      },
                                      on: { click: _vm.nextPage },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("personalCenter.next"))
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ])
                        : _vm.category === "vip"
                        ? _c("VipMemberOverview", {
                            attrs: { "game-data": _vm.gameData },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ]),
          _c("Footer"),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }